import { useEffect, useMemo, useState } from 'react';
import type React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

interface TestEmailDialogProps {
  open: boolean;
  sending: boolean;
  onClose: () => void;
  onSend: (emails?: string[]) => void;
}

const parseEmails = (values: string[]) =>
  values
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean)
    .slice(0, 3);

export const TestEmailDialog: React.FC<TestEmailDialogProps> = ({
  open,
  sending,
  onClose,
  onSend,
}) => {
  const [emails, setEmails] = useState(['', '', '']);
  const parsedEmails = useMemo(() => parseEmails(emails), [emails]);

  useEffect(() => {
    if (!open) setEmails(['', '', '']);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Send email test</DialogTitle>
      <DialogContent className="space-y-3">
        <p className="text-sm text-gray-600 dark:text-slate-300">
          Leave all fields empty to send to your admin email.
        </p>
        {emails.map((value, index) => (
          <TextField
            key={`email-${index}`}
            fullWidth
            type="email"
            label={`Email ${index + 1}`}
            value={value}
            onChange={(event) =>
              setEmails((current) =>
                current.map((item, itemIndex) => (itemIndex === index ? event.target.value : item))
              )
            }
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={sending}
          onClick={() => onSend(parsedEmails.length > 0 ? parsedEmails : undefined)}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};
